<div class="posters-page">
  <div class="row posters-upload-section">
    <div class="col">
      <google-cloud-uploader [createPoster]="true"></google-cloud-uploader>
    </div>
  </div>

  <div class="row posters-toolbar">
    <div class="col-6 posters-filters">
      <br />
      <div class="row">
        <div class="col-auto">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Shop' | translate }}</mat-label>
            <mat-select [(ngModel)]="searchShopStatus">
              <mat-option [value]="'ALL'">{{ 'Alla' | translate }}</mat-option>
              <mat-option [value]="'CONNECTED'">{{ 'Kopplade' | translate }}</mat-option>
              <mat-option [value]="'NOT_CONNECTED'">{{ 'Ej kopplade' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-auto">
          <mat-form-field class="fullwidth">
            <mat-label>{{ 'Sök' | translate }}</mat-label>
            <input matInput [(ngModel)]="searchText">
          </mat-form-field>
        </div>
        <div class="col posters-search-action">
          <button mat-raised-button color="primary" (click)="search()">{{ 'Sök' | translate }}</button>
        </div>
      </div>
    </div>
    <div class="col-6 align-right posters-create-action">
      <br />
      <button mat-raised-button color="primary" (click)="newPoster()">{{ 'Skapa ny' | translate }}</button>
    </div>
  </div>
  <div class="row posters-table-section">

    <div class="col-12">
      <table class="fullwidth styled">
        <tr>
          <th></th>
          <th>{{ 'Namn' | translate }}</th>
          <th class="align-right">{{ 'Skapad' | translate }}</th>
        </tr>
        <tr *ngFor="let poster of posters">
          <td>
            <img class="thumb" *ngIf="poster.thumbnail" [src]="poster.thumbnail.url" />
          </td>
          <td>
            <a [routerLink]="[globals.panelUrl('/posters/' + poster._id)]">{{poster.name}}</a>
          </td>
          <td class="align-right">{{poster.created | date : 'yyyy-MM-dd HH:mm'}}</td>
        </tr>
      </table>
    </div>
  </div>
</div>
